import { SanitizedWarrantySelection } from "@dune/types";
import { PricingOptionsProvider } from "./contexts/PricingOptionsContext";
import BinderWarrantyOfferContainer from "./BinderWarrantyOfferContainer";
import BinderWarrantyOfferOptionsContainer from "./BinderWarrantyOfferOptionsContainer";
import WarrantiesAccordion from "./WarrantiesAccordion";
import { useOfferHasDerogation } from "../../../api/queries/derogations.queries";

type BinderWarrantyOfferContainerWithOptionsAndPricingProviderProps = {
	binderWarranty: SanitizedWarrantySelection;
	constructionSiteId: string;
	isDisabled: boolean;
	handleBinderWarrantyCheckboxChange: (id: number) => void;
	handleDependentWarrantyCheckboxChange: (
		baseWarrantyId: number,
		id: number,
	) => void;
	handleBinderWarrantyWarrantyCheckboxChange: (
		baseWarrantyId: number,
		id: number,
	) => void;
	handleBinderWarrantyWarrantyLimitChange: (
		baseWarrantyId: number,
		warrantyId: number,
		limitOptionId: number,
	) => void;
	handleBrokerFeesChange: (baseWarrantyId: number, brokerFees: number) => void;
};

export const BinderWarrantyOfferContainerWithOptionsAndPricingProvider = (
	props: BinderWarrantyOfferContainerWithOptionsAndPricingProviderProps,
) => {
	const {
		binderWarranty,
		constructionSiteId,
		isDisabled,
		handleBinderWarrantyCheckboxChange,
		handleDependentWarrantyCheckboxChange,
		handleBinderWarrantyWarrantyCheckboxChange,
		handleBinderWarrantyWarrantyLimitChange,
		handleBrokerFeesChange,
	} = props;

	const { data: offerHasDerogation } = useOfferHasDerogation(
		Number(constructionSiteId),
		binderWarranty.id,
	);

	return (
		<PricingOptionsProvider key={binderWarranty.id}>
			<div className="flex flex-col gap-4 w-[30%] min-w-[300px] flex-shrink-0">
				<BinderWarrantyOfferContainer
					binderWarranty={binderWarranty}
					handleBinderWarrantyCheckboxChange={
						handleBinderWarrantyCheckboxChange
					}
					constructionSiteId={constructionSiteId}
					storedPricingType={offerHasDerogation ? "INITIAL" : undefined}
					isDisabled={isDisabled}
				/>
				{binderWarranty.checked && (
					<BinderWarrantyOfferOptionsContainer
						binderWarranty={binderWarranty}
						constructionSiteId={constructionSiteId}
						handleDependentWarrantyCheckboxChange={
							handleDependentWarrantyCheckboxChange
						}
						handleBinderWarrantyWarrantyCheckboxChange={
							handleBinderWarrantyWarrantyCheckboxChange
						}
						handleBinderWarrantyWarrantyLimitChange={
							handleBinderWarrantyWarrantyLimitChange
						}
						handleBrokerFeesChange={handleBrokerFeesChange}
						storedPricingType={offerHasDerogation ? "INITIAL" : undefined}
						isDisabled={isDisabled}
					/>
				)}
				{binderWarranty.checked && (
					<WarrantiesAccordion binderWarranty={binderWarranty} />
				)}
			</div>
		</PricingOptionsProvider>
	);
};
